var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BCEA0902-6AE1-450F-A591-334D7BE11D88") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2943321,0 L2.70566792,0 C1.21413452,0 0,1.21331138 0,2.70566792 L0,11.2943321 C0,12.7866886 1.21413452,14 2.70566792,14 L11.2943321,14 C12.7858655,14 14,12.7866886 14,11.2943321 L14,2.70566792 C14,1.21331138 12.7858655,0 11.2943321,0 L11.2943321,0 Z M12.070555,1.61418156 L12.3800564,1.61253528 L12.3800564,3.98565381 L10.0143462,3.99306209 L10.0061148,1.61994356 L12.070555,1.61418156 L12.070555,1.61418156 Z M5.00223424,5.56279398 C5.45002352,4.94214487 6.17768109,4.5355127 7,4.5355127 C7.82231891,4.5355127 8.54997648,4.94214487 8.99776576,5.56279398 C9.28998119,5.96777987 9.4644873,6.46331138 9.4644873,7 C9.4644873,8.35818438 8.35900753,9.46366416 7,9.46366416 C5.64181562,9.46366416 4.53633584,8.35818438 4.53633584,7 C4.53633584,6.46331138 4.71084196,5.96777987 5.00223424,5.56279398 L5.00223424,5.56279398 Z M12.6360536,11.2943321 C12.6360536,12.0343368 12.0343368,12.6360536 11.2943321,12.6360536 L2.70566792,12.6360536 C1.96566322,12.6360536 1.36394638,12.0343368 1.36394638,11.2943321 L1.36394638,5.56279398 L3.45472719,5.56279398 C3.27363594,6.00729069 3.17238946,6.49212135 3.17238946,7 C3.17238946,9.11053622 4.88946378,10.8284337 7,10.8284337 C9.11135936,10.8284337 10.8284337,9.11053622 10.8284337,7 C10.8284337,6.49212135 10.7255409,6.00729069 10.546096,5.56279398 L12.6360536,5.56279398 L12.6360536,11.2943321 L12.6360536,11.2943321 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-v1.5---1.1---Arccos---Insight-Detail---1",
    transform: "translate(-947.000000, -1006.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(472.000000, 928.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(42.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Social/Instagram",
    transform: "translate(433.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#2C2C2C",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-color",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -5.000000)",
    id: "Black"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b401bd441f8613c6a633c7a7e38fb660.svg";
export { ForwardRef as ReactComponent };